import { render } from "./ebioChart.vue?vue&type=template&id=029d935a&scoped=true"
import script from "./ebioChart.vue?vue&type=script&lang=js"
export * from "./ebioChart.vue?vue&type=script&lang=js"

import "./ebioChart.vue?vue&type=style&index=0&id=029d935a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-029d935a"]])

export default __exports__